// NOTE: If additional date functions are needed, consider using dayjs.

export const resetTimeToZero = (date: Date | string): Date => {
  const dateOnly = new Date(date);
  dateOnly.setHours(0, 0, 0, 0);

  return dateOnly;
};
